import {appUrl} from '@frontend/AppUrl'
import {trans} from '@frontend/helpers'
import {
    mdiHelpCircleOutline,
    mdiNewspaperVariantOutline,
    mdiWalletBifoldOutline,
} from '@mdi/js'
import {NavLink} from 'react-router-dom'
import {Icon} from 'swayok-react-mdb-ui-kit/components/Icon/Icon'
import {AppConfig} from '../../../AppConfig'

// Ссылки верхнего меню в личном кабинете пользователя.
export function CabinetLinks() {

    return (
        <nav className="top-nav-links cabinet-nav d-flex flex-column align-items-stretch flex-lg-row align-items-lg-center flex-1">
            <NavLink
                to={appUrl().cabinet.ads.index}
                className="mx-lg-2"
            >
                <Icon
                    path={mdiNewspaperVariantOutline}
                    className="nav-link-icon"
                />
                {trans().cabinet.top_navigation.my_ads}
            </NavLink>
            <NavLink
                to={
                    AppConfig.features?.advances?.enabled
                        ? appUrl().cabinet.advancePayments.contract
                        : appUrl().cabinet.transactions.index
                }
                className="mx-lg-2"
            >
                <Icon
                    path={mdiWalletBifoldOutline}
                    className="nav-link-icon"
                />
                {trans().cabinet.top_navigation.my_money}
            </NavLink>
            <NavLink
                to={appUrl().support.index}
                className="mx-lg-2"
            >
                <Icon
                    path={mdiHelpCircleOutline}
                    className="nav-link-icon"
                />
                {trans().common.top_navigation.support}
            </NavLink>
        </nav>
    )
}
